import type { ZodType } from "zod";
import z from "zod";

import {
  ConveyedPersonActionSchema,
  type ConveyedPersonAction,
} from "./involvement.js";

/**
 * What may be asked of a person's record. `start_assessment`, `archive`
 * and `end_guest_access` are not conveyed by any involvement: each is worked
 * out from the record as a whole, or from what else is held over it (whether
 * its profile is active, who may archive it, and `mayEndGuestAccess`), so none
 * appears in what an involvement reports.
 */
export type PersonAction =
  ConveyedPersonAction | "start_assessment" | "archive" | "end_guest_access";

export const PersonActionSchema = z.enum([
  ...ConveyedPersonActionSchema.options,
  "start_assessment",
  "archive",
  "end_guest_access",
]) satisfies ZodType<PersonAction>;
